import React, { useState } from 'react';
import { FieldTable } from './FieldTable';
import { FieldTableOptionalProps, IdedType } from './FieldTableTypes';
import { useEffect } from 'react';
import {Button, List, ListItemIcon, Menu, MenuItem, Paper, Popover} from "@mui/material";
import {Check} from "@mui/icons-material";
import { useToast } from "../../contexts/toast";


/* support code for optional columns, 
    needs adding to the graphql and field table definition as per posterSizes (region mode) 
*/


export function FieldTableOptional<Type extends IdedType>(props:FieldTableOptionalProps<Type,any>) {
    const [columns,setColumns] = useState(props.columns);
    const [shownColumns,setShownColumns] = useState<string[]>([]);
    const { toast } = useToast();
    useEffect(()=>{
        const p = [...props.columns];
        const localShownColumns = [];
        props?.shownColumns?.forEach((columnId)=>{
            const column = props.optionalColumns[columnId];
            p.push(column);
            localShownColumns.push(column?.accessor);
        });
        setColumns(p);
        setShownColumns(localShownColumns);
    },[props.columns, props.optionalColumns, props.shownColumns]);
    const handleClick = (column)=>(evt) => {
        setShownColumns((v) => {
            if(v.indexOf(column.accessor)>-1) {
                v = v.filter((temp)=>temp!=column.accessor);
            } else {
                if(v.length>=props.maxOptionalColumns) {
                    toast('Max of '+props.maxOptionalColumns+' columns',{variant:'error',id:'FTO_COL_WARN'});
                    return v;
                }
                v.push(column.accessor);
            }
            return [...v];
        });
    }
    const isSelected = (id)=>shownColumns.indexOf(id)>-1;
    const menuItems = props.optionalColumns.map((column)=>{
        return <MenuItem key={column.accessor}
        onClick={handleClick(column)}
        >
        <ListItemIcon>
            {isSelected(column.accessor)&&<Check />}
        </ListItemIcon>{column.header}</MenuItem>
    });
    const applyColumns = (evt)=>{
        const colLookups = {};
        props.optionalColumns.forEach((col,idx)=>{
            colLookups[col.accessor] = idx;
        })
        const columnIds = shownColumns.map((v)=>{
            return colLookups[v];
        })
        props.setShownColumns(columnIds);
        props.setIsOptionalListOpen(null);
    }
    return <>
    {!props.form?.isDirty &&<Popover className="field-table__options-toggle" open={!!props.isOptionalListOpen} key="toggle-optionals"
                                    anchorEl={props.isOptionalListOpen} anchorOrigin={{horizontal:"right",vertical:"bottom"}} onClose={()=>props.setIsOptionalListOpen(null)}>
        <Paper>
        <List sx={{maxHeight:"60vh",overflowY:"auto"}}>{menuItems}</List>
            <Button variant="contained" color="success" onClick={applyColumns} fullWidth={true} startIcon={<Check/>}>Apply Columns</Button>
        </Paper>
    </Popover>
    }
        <FieldTable {...props} columns={columns} />
    </>
}